export default "__VITE_ASSET__D_HWblG1__"